<template>
  <div>
    <XsRewards v-if="$vuetify.breakpoint.xsOnly" />
    <div v-else>
      <RewardsPoints v-if="hasPoints" />
      <RewardsClubs v-if="hasClubs" />
    </div>
  </div>
</template>

<script>
import RewardsPoints from "./Points.vue";
import RewardsClubs from "./Clubs.vue";
import XsRewards from "./Xs/index.vue";
import { mapGetters } from 'vuex';

export default {
  name: "Rewards",
  components: {
    RewardsPoints,
    RewardsClubs,
    XsRewards,
  },
  created() {
    this.$store.dispatch("store/fetchPoints");
    this.$store.dispatch("store/fetchClubs");
  },
  computed: {
    ...mapGetters('store', { hasPoints: 'hasPoints', hasClubs: 'hasClubs' }),
  },
};
</script>
<style>
.click-to-see-rewards {
  opacity: 0.6;
  font-family: IDTSans, sans-serif;
  font-size: 14px;
  line-height: 1.1;
  letter-spacing: -0.42px;
  color: #000;
}
.font-24 {
  font-size: 24px;
}
.header-text {
  font-family: Roboto, sans-serif;
  font-size: 18px;
  font-weight: 600;
}
.main-header {
  border-radius: 8px;
  background-color: var(--v-secondary-base);
  color: white;
}
.points-header {
  border-radius: 8px 8px 0 0;
  background-color: var(---v-background-base);
}
.tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: IDTSans, sans-serif;
  font-size: 14px;
}
</style>
